export default {
  crypto: {
    signature: 'Signature',
    algorithm: '算法',
    value: '值'
  }
}
